import React, { useState } from 'react';
import { __ } from 'i18n/index';
import TextWithElements from 'react/elements/TextWithElements';
import { dismissConnectCode, myConnectCode, saveMyConnectCode, undismissConnectCode } from 'components/connectCode';

// Under your own message in a room when it holds a connect code you haven't
// saved (offer: {code, type, name}, the ladder's field): Add to profile (or
// Replace the one you have) and Not mine, each with Undo. Only you see it
// (ChatMessages.offerConnectCode decides when).
export default function ConnectCodeOfferCard({ offer }) {
	const { code, type, name } = offer;
	const [previous, setPrevious] = useState(() => myConnectCode(type));
	const [state, setState] = useState('asking');
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState(null);
	const codeElement = (key) => <span key={key} className='chat-slippi-card__code'>{code}</span>;

	const saveValue = (value, nextState) => {
		setSaving(true);
		setError(null);
		saveMyConnectCode(type, value)
			.then(() => setState(nextState))
			.catch((reason) => setError(String(reason)))
			.finally(() => setSaving(false));
	};
	const save = () => {
		setPrevious(myConnectCode(type));
		saveValue(code, 'saved');
	};
	const undoSave = () => saveValue(previous || '', 'asking');
	const notMine = () => {
		dismissConnectCode(code);
		setState('dismissed');
	};
	const undoNotMine = () => {
		undismissConnectCode(code);
		setState('asking');
	};

	if(state === 'saved' || state === 'dismissed') {
		const saved = state === 'saved';
		return (
			<div className='chat-slippi-card chat-slippi-card--done' data-testid='slippi-code-offer'>
				<i className={'fa ' + (saved ? 'fa-check' : 'fa-eye-slash')} aria-hidden='true' />
				<span className='chat-slippi-card__title'>
					{saved
						? <TextWithElements text={__('%s is now your %s.')} elements={[codeElement('code'), name]} />
						: <TextWithElements text={__('Got it. We won\'t ask about %s again.')} elements={[codeElement('code')]} />}
				</span>
				<button type='button' className='chat-slippi-card__link' disabled={saving} onClick={saved ? undoSave : undoNotMine}>{__('Undo')}</button>
				{error && <span className='chat-slippi-card__error' role='alert'>{error}</span>}
			</div>
		);
	}

	const existing = myConnectCode(type);
	return (
		<div className='chat-slippi-card' data-testid='slippi-code-offer'>
			<span className='chat-slippi-card__icon'><i className='fa fa-gamepad' aria-hidden='true' /></span>
			<div className='chat-slippi-card__body'>
				<div className='chat-slippi-card__title'>
					<TextWithElements text={__('Is %s your %s?')} elements={[codeElement('code'), name]} />
				</div>
				<div className='chat-slippi-card__help'>
					{existing
						? <TextWithElements text={__('Your profile has %s. Replace it so opponents connect to the right one.')} elements={[<span key='existing' className='chat-slippi-card__code'>{existing}</span>]} />
						: __('Add it to your profile and opponents can connect without asking in chat.')}
				</div>
				<div className='chat-slippi-card__actions'>
					<button type='button' className='chat-slippi-card__button chat-slippi-card__button--primary' disabled={saving} onClick={save}>
						{existing ? __('Replace %s', existing) : __('Add to profile')}
					</button>
					<button type='button' className='chat-slippi-card__button' disabled={saving} onClick={notMine}>{__('Not mine')}</button>
					<span className='chat-slippi-card__only-you'><i className='fa fa-eye' aria-hidden='true' /> {__('Only you can see this')}</span>
				</div>
				{error && <span className='chat-slippi-card__error' role='alert'>{error}</span>}
			</div>
		</div>
	);
}
